import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { computed, onMounted, onUpdated, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomModal',
  props: {
    show: { type: Boolean },
    modal: { type: Boolean },
    size: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean;
  modal?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
};





const containerCss = computed(() => {
  let css = "modal--container";
  if (props.size) {
    css += `-${props.size}`;
  }

  return css;
})

const removeBackgroundDiv = () => {
  const elements = document.getElementsByClassName("modal-background");
  if (elements.length > 0) {
    const bgDiv = elements[0] as HTMLDivElement;
    bgDiv.remove();
  }
}

const handleClose = () => {
  if (!props.modal) {
    emit("close");
  }
}

const handleBodyClass = () => {
  const elements = document.getElementsByTagName("body");
  if (elements.length > 0) {
    const body = elements[0] as HTMLBodyElement;
    if (props.show) {
      body.classList.add("modal-open");

      if (document.getElementsByClassName("modal-background").length === 0) {
        const bgDiv = document.createElement("div");
        bgDiv.classList.add("modal-background");
        body.appendChild(bgDiv);
      }
    } else {
      body.classList.remove("modal-open");

      removeBackgroundDiv();
    }
  }
}


onMounted(handleBodyClass)

onUpdated(() => {
  if (!props.show) {
    removeBackgroundDiv();
  }
})

watch(() => props.show, handleBodyClass)

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal",
        onClick: _withModifiers(handleClose, ["self"])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_unref(containerCss))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})